<PluginOutlet @name="admin-wizards-top" @connectorTagName="div" />

{{#admin-nav}}
  {{nav-item route="adminWizardsWizard" label="admin.wizard.nav_label"}}
  {{nav-item
    route="adminWizardsCustomFields"
    label="admin.wizard.custom_field.nav_label"
  }}
  {{nav-item
    route="adminWizardsSubmissions"
    label="admin.wizard.submissions.nav_label"
  }}
  {{#if this.showApi}}
    {{nav-item route="adminWizardsApi" label="admin.wizard.api.nav_label"}}
  {{/if}}
  {{nav-item route="adminWizardsLogs" label="admin.wizard.log.nav_label"}}
  {{nav-item
    route="adminWizardsManager"
    label="admin.wizard.manager.nav_label"
  }}
{{/admin-nav}}

<div class="admin-container">
  {{outlet}}
</div>